import {ObjectDTO} from "../object-dto";
import {PointDeLivraisonDTO} from "../point-de-livraison-d-t-o";

export class PointTeledeclarationEgalimDto extends ObjectDTO {
  siret: string;
  pointLivraisonClientList: PointDeLivraisonDTO[];
  emailAddress: string;

  public static getAllProperties = (): String => {
    return `
      id,
      code,
      libelle,
      actif,
      siret,
      emailAddress,
      site {
        id,
        libelle
      }
      pointLivraisonClientList {
        id,
        libelle
      }
    `
  }
}
